// Moeda pt-BR em um só lugar: "R$ 1.234,56" (com espaço e vírgula decimal).

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/** Valor em reais para exibição. Aceita número ou string ("2.90"); vazio/ inválido vira R$ 0,00. */
export function formatBRL(value: number | string | null | undefined): string {
    return BRL.format(toAmount(value));
}

/** Converte o que vier da API ("2.90", 2.9, null) em número. */
export function toAmount(value: number | string | null | undefined): number {
    const amount = typeof value === 'string' ? Number.parseFloat(value) : Number(value);
    return Number.isFinite(amount) ? amount : 0;
}

/** Opções do `currencyMask` (ngx-currency) para campos em reais. */
export const BRL_MASK_OPTIONS = Object.freeze({
    prefix: 'R$ ',
    thousands: '.',
    decimal: ',',
    align: 'left',
});
